export default __webpack_public_path__ + "assets/icons/take-picture.f40fe1df.svg";